import React from "react";
import Layout from "../components/organisms/layout/layout";
import SEO from "../shared/seo";
import "./../styles/index.scss";
import { ReferenciaOrganismos } from "../interfaces/ReferenciaOrganismos";
import LibraryComponents from "../components/templates/library-components/libraryComponents";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import Suscribe from "../components/molecules/suscribe/suscribe";
import WhatsappGroup from "../components/molecules/whatsapp-group/whatsappGroup";
import { adapterSuscribe } from "../components/templates/library-components/adapters";

const IndexPage = (props: any | undefined) => {
  const Componentes: ReferenciaOrganismos[] =
    props?.pageContext.allContentfulHome.edges[0].node.referenciaOrganismos;
    const metaTitle = props?.pageContext.allContentfulHome.edges[0].node.titulo;
    const metaDescription = props?.pageContext.allContentfulHome.edges[0].node.metaDescripcion;

  return (
    <Layout hideHeaderDesktop={false} hideHeaderMobile={false} showPlayer={true}>
        <SEO
          title={ metaTitle + " | Home" || "Revista Comfama | Home" } 
          description={ metaDescription && metaDescription.json.content[0].content[0].value } 
          lang="es"
        />
      {Componentes.map((value: any, index: number) => (
        <section id={"section" + index} key={`section-${index}`}>
          <LibraryComponents content={value} categoryName={"Home"} />
        </section>
      ))}
      <WhatsappGroup />
      <Suscribe {...adapterSuscribe()} />
      <Disclaimer />
    </Layout>
  );
};

export default IndexPage;
